import React from 'react'

import { useAuth } from 'quantic/hooks'
import NotAuthenticatedLayout from 'components/templates/Layout/NotAuthenticated'
import { Tabs } from 'quantic'

import Login from './Login'
import Register from './Register'

function Authentication() {
  const { signIn } = useAuth()

  const onSubmitLogin = async (params) => {
    // const { data, error } = await authenticate(params)
    signIn(params)
  }

  const onSubmitRegister = async (params) => {
    // const { data, error } = await register(params)
    signIn(params)
  }

  return (
    <NotAuthenticatedLayout>
      <Tabs>
        <Tabs.Item title="Entrar">
          <Login onSubmitLogin={onSubmitLogin} />
        </Tabs.Item>
        <Tabs.Item title="Cadastrar">
          <Register onSubmitRegister={onSubmitRegister} />
        </Tabs.Item>
      </Tabs>
    </NotAuthenticatedLayout>
  )
}

export default Authentication
